<div class="grid grid-cols-2 fullhd:grid-cols-2 gap-4">
  <section class="bm-card bm-card-sm bm-card-border border-base-300">
    <div class="bm-card-body mt-2">
      <h3 class="bm-card-title bm-card-title-top px-1 bg-base-100">
        Beauftragung
        <button
          class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost opacity-25 hover:opacity-100"
          (click)="editDescription = !editDescription"
        >
          @if (editDescription) {
            <fa-icon [icon]="['far', 'times']" />
          } @else {
            <fa-icon [icon]="['far', 'edit']" />
          }
        </button>
      </h3>
      @if (editDescription) {
        <hawk-shared-edit-input
          [textValue]="operation.description"
          [modus]="'textarea'"
          (saveClicked)="saveDescription($event)"
          (cancelClicked)="editDescription = false"
        />
      } @else {
        <p class="description" [innerHtml]="convertLinebreaks(operation.description, true)"></p>
      }
    </div>
  </section>

  <section class="bm-card bm-card-sm bm-card-border border-base-300">
    <div class="bm-card-body mt-2">
      <h3 class="bm-card-title bm-card-title-top px-1 bg-base-100">
        Ai Zusammenfassung
        <button
          class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost opacity-25 hover:opacity-100"
          (click)="editDescriptionAi = !editDescriptionAi"
        >
          @if (editDescriptionAi) {
            <fa-icon [icon]="['far', 'times']" />
          } @else {
            <fa-icon [icon]="['far', 'edit']" />
          }
        </button>
      </h3>
      @if (editDescriptionAi) {
        <hawk-shared-edit-input
          [textValue]="operation.description_ai"
          [modus]="'textarea'"
          (saveClicked)="saveDescriptionAi($event)"
          (cancelClicked)="editDescriptionAi = false"
        />
      } @else {
        <p class="description_ai" [innerHtml]="convertLinebreaks(operation.description_ai, true)"></p>
        <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editItemCount = !editItemCount">
                  <span>Anzahl Stationen/Waagen</span>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editItemCount) {
                  <dd>{{ operation?.item_count || '-' }}</dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [numberValue]="operation.item_count"
                    [modus]="'number'"
                    (saveClicked)="saveItemCount($event)"
                    (cancelClicked)="editItemCount = false"
                  />
                }
                <dt (click)="editAiCorrect = !editAiCorrect">
                  <span>Ai Berechnung korrekt?</span>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>

              @if (!editAiCorrect) {
                @if (operation.ai_calculation_correct) {
                   <dd><fa-icon [icon]="['far', 'check']" /></dd>
                }
              } @else {
                <hawk-shared-edit-input
                  [boolValue]="operation.ai_calculation_correct"
                  [modus]="'checkbox'"
                  (saveClicked)="saveOperationAiCorrect($event)"
                  (cancelClicked)="editAiCorrect = false"
                />
              }
              </dl>

      }
    </div>
  </section>
</div>

<div class="operationSubpage">
  <section class="mt-3">
    <div class="bm-tabs bm-tabs-box" role="tablist">
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('overview')"
        (click)="selectedTab = 'overview'"
      >
        Rückmeldung
      </button>
      @if(checklist) {
        <button role="tab" class="bm-tab" [class.bm-tab-active]="isTabSelected('checklist')" (click)="selectedTab = 'checklist'">Checkliste</button>
      }
      <button role="tab" class="bm-tab" [class.bm-tab-active]="isTabSelected('operation_data')" (click)="selectedTab = 'operation_data'">
        Einsatzdaten
      </button>
      <button role="tab" class="bm-tab" [class.bm-tab-active]="isTabSelected('steps')" (click)="selectedTab = 'steps'">
        Schritte
      </button>
      @if (ticket.is_mt) {
        <button
          role="tab"
          class="bm-tab"
          [class.bm-tab-active]="isTabSelected('mt_result')"
          (click)="selectedTab = 'mt_result'"
        >
          MT Ergebnis
        </button>
      }
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('material')"
        (click)="selectedTab = 'material'"
      >
        Material
      </button>
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('delivery_notes')"
        (click)="selectedTab = 'delivery_notes'"
      >
        Lieferscheine
      </button>
      @if (isBookkeeper) {
        <button
          role="tab"
          class="bm-tab"
          [class.bm-tab-active]="isTabSelected('billing')"
          (click)="selectedTab = 'billing'"
        >
          Abrechnung
        </button>
      }
      <button role="tab" class="bm-tab" [class.bm-tab-active]="isTabSelected('files')" (click)="selectedTab = 'files'">
        Dateien
      </button>
      <button
        role="tab"
        class="bm-tab"
        [class.bm-tab-active]="isTabSelected('extras')"
        (click)="selectedTab = 'extras'"
      >
        Extras
      </button>
      @if (ticket.is_mt) {
        <button
          role="tab"
          class="bm-tab"
          [class.bm-tab-active]="isTabSelected('mt_bonus')"
          (click)="selectedTab = 'mt_bonus'"
        >
          MT Spezial
        </button>
      }

      <div class="bm-tab-content bg-base-100 border-base-100 p-3">
        @if (selectedTab == "overview") {
          <div class="grid grid-cols-2 fullhd:grid-cols-3 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">Details</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt>ID</dt>
                <dd>{{ operation?.id }}</dd>

                <dt (click)="editOperationDate = !editOperationDate">
                  <span>Plandatum</span>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editOperationDate) {
                  <dd>{{ operation.operation_date | date: "dd.MM.yyyy HH:mm" }}</dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [textValue]="operation.operation_date"
                    [modus]="'date'"
                    (saveClicked)="saveOperationDate($event)"
                    (cancelClicked)="editOperationDate = false"
                  />
                }

                <dt (click)="editDateFixed = !editDateFixed">
                  <span>Fixtermin?</span>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editDateFixed) {
                  <dd>
                    @if (operation.date_fixed) {
                      <fa-icon [icon]="['far', 'check']" />
                    } @else {
                      <span>nein</span>
                    }
                  </dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [boolValue]="operation.date_fixed"
                    [modus]="'checkbox'"
                    (saveClicked)="saveDateFixed($event)"
                    (cancelClicked)="editDateFixed = false"
                  />
                }

                <dt
                  [class.self-start]="editTechnicians"
                  (click)="editTechnicians ? (editTechnicians = false) : openTechnicianForm()"
                >
                  Techniker
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editTechnicians) {
                  <dd>
                    @for (tech of operation.technicians; track $index) {
                      <a routerLink="/benutzer/{{ tech.id }}" target="_blank" class="bm-link bm-link-hover">
                        {{ tech.full_name }}
                      </a>
                      @if (tech.phone1) {
                        (<a href="tel:{{ tech.phone1 }}" class="bm-link bm-link-hover">{{ tech.phone1 }}</a
                        >)
                      }
                    }
                  </dd>
                } @else {
                  <dd class="col-span-2">
                    <div class="flex flex-row items-center gap-1">
                      <b class="w-full">bisher ausgewählt</b>
                      <div class="bm-join">
                        <button class="bm-join-item bm-btn bm-btn-sm bm-btn-primary" (click)="saveTechnicians()">
                          <fa-icon [icon]="['far', 'save']" />
                        </button>
                        <button
                          class="bm-join-item bm-btn bm-btn-sm bm-btn-square bm-btn-ghost"
                          (click)="editTechnicians = false"
                        >
                          <fa-icon [icon]="['far', 'times']" />
                        </button>
                      </div>
                    </div>
                    @for (technician of selectedTechnicians(); track $index) {
                      <div class="flex flex-row gap-1 items-center">
                        <span>
                          {{ technician.name }}
                        </span>
                        @if (technician.company) {
                          <small>({{ technician.company }})</small>
                        }
                        <button
                          class="bm-join-item bm-btn bm-btn-sm bm-btn-square bm-btn-ghost bm-bm-btn-ghost"
                          (click)="removeTechnician(technician.id)"
                        >
                          <fa-icon [icon]="['fas', 'trash']" />
                        </button>
                      </div>
                    }
                    <input
                      type="text"
                      class="bm-input w-full"
                      placeholder="Technikername suchen"
                      [(ngModel)]="techicianSearchboxValue"
                    />
                    @for (
                      technician of technicians | technicianFilter: techicianSearchboxValue | slice: 0 : 5;
                      track $index
                    ) {
                      <div class="flex flex-row gap-1 items-center">
                        <span>
                          {{ technician.name }}
                        </span>
                        @if (technician.company) {
                          <small>({{ technician.company }})</small>
                        }
                        <button
                          class="bm-join-item bm-btn bm-btn-sm bm-btn-square bm-btn-ghost bm-bm-btn-ghost"
                          (click)="addTechnician(technician.id)"
                        >
                          <fa-icon [icon]="['fas', 'user-plus']" />
                        </button>
                      </div>
                    }
                  </dd>
                }

                <div class="bm-divider my-0 col-span-3"></div>

                <dt (click)="editStatus = !editStatus">
                  Status
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editStatus) {
                  <dd>{{ status() }}</dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [textValue]="operation.status"
                    [selectOptions]="statusOptions"
                    [modus]="'select'"
                    (saveClicked)="saveStatus($event)"
                    (cancelClicked)="editStatus = false"
                  />
                }
                @if (operation.metadata) {
                  <dt (click)="toggleStepStatus()">
                    Schrittstatus
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </dt>
                  @if (!editStepstatus) {
                    <dd>{{ stepStatus() }}</dd>
                  } @else {
                    <dd>
                      <button class="bm-btn" (click)="markStepDone()">Schritte abschließen!</button><br />
                      <small>{{ stepWarning }}</small>
                    </dd>
                    <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="toggleStepStatus()">
                      <fa-icon [icon]="['far', 'times']" />
                    </button>
                  }
                }

                <div class="bm-divider my-0 col-span-3 row-"></div>

                <dt (click)="editTravelStart = !editTravelStart">
                  Reisebeginn
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editTravelStart) {
                  <dd>
                    {{ operation.date_travel_start | date: "dd.MM.yyyy HH:mm" }}
                  </dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [dateValue]="operation.date_travel_start"
                    [modus]="'date'"
                    (saveClicked)="saveTravelStart($event)"
                    (cancelClicked)="editTravelStart = false"
                  />
                }

                <dt (click)="editArrival = !editArrival">
                  Ankunft
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editArrival) {
                  <dd>
                    {{ operation.date_on_site | date: "dd.MM.yyyy HH:mm" }}
                  </dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [dateValue]="operation.date_on_site"
                    [modus]="'date'"
                    (saveClicked)="saveArrival($event)"
                    (cancelClicked)="editArrival = false"
                  />
                }

                <dt (click)="editRepaired = !editRepaired">
                  Wiederhergestellt
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editRepaired) {
                  <dd>
                    {{ operation.date_repaired | date: "dd.MM.yyyy HH:mm" }}
                  </dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [dateValue]="operation.date_repaired"
                    [modus]="'date'"
                    (saveClicked)="saveRepaired($event)"
                    (cancelClicked)="editRepaired = false"
                  />
                }

                <dt (click)="editFinished = !editFinished">
                  Abgeschlossen
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editFinished) {
                  <dd>
                    {{ operation.date_finished | date: "dd.MM.yyyy HH:mm" }}
                  </dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [dateValue]="operation.date_finished"
                    [modus]="'date'"
                    (saveClicked)="saveFinished($event)"
                    (cancelClicked)="editFinished = false"
                  />
                }

                <dt (click)="editDistance = !editDistance">
                  Entfernung
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                @if (!editDistance) {
                  <dd>
                    @if (operation.travel_distance && operation.travel_duration) {
                      <span>
                        {{ operation.travel_distance | number: "1.0-0" }} km,
                        {{ operation.travel_duration | number: "1.0-0" }} min,
                      </span>
                    }
                    <span> Luft: {{ operation.calculated_distance }} km </span>
                    @if (operation.distance && operation.distance > 0) {
                      <span>, Rückmeldung: {{ operation.distance | number: "1.0-0" }} km</span>
                    }
                  </dd>
                } @else {
                  <hawk-shared-edit-input
                    class="col-span-2"
                    [numberValue]="operation.distance"
                    [modus]="'number'"
                    (saveClicked)="saveDistance($event)"
                    (cancelClicked)="editDistance = false"
                  />
                }
                <dt>GPS</dt>
                <dd>not implemented yet</dd>
              </dl>
            </section>
            <div class="flex flex-col gap-4 fullhd:col-span-2">
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title bm-card-title-top bg-base-100 flex flex-row gap-1">
                  <span> Gewechselte Teile </span>
                  <button
                    class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost bm-tooltip"
                    data-tip="Neues Teil"
                    (click)="newPartForm = true"
                  >
                    <fa-icon [icon]="['far', 'plus']" />
                  </button>
                </h3>
                @if (parts) {
                  <div class="overflow-y-auto" [style.max-height.px]="400">
                    <table class="bm-table bm-table-sm bm-table-pin-rows" >
                      <thead>
                        <tr>
                          <th>RMA</th>
                          <th>Typ</th>
                          <th>SN eingebaut</th>
                          <th>SN ausgebaut</th>
                          <th>Fehlerbeschreibung</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (part of parts; track $index) {
                          @if (part !== selectedPart) {
                            <tr>
                              @if (part.article) {
                                <td>
                                  <a href="/a/artikel/{{ part.article?.id }}" target="_blank">{{ part.rma }}</a>
                                </td>
                              } @else {
                                <td>{{ part.rma }}</td>
                              }
                              <td>{{ part.article?.description }}</td>
                              <td>{{ part.newsn }}</td>
                              <td>{{ part.oldsn }}</td>
                              <td>{{ part.description }}</td>
                            </tr>
                          }
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </section>
              @if (newPartForm) {
                <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                  <h3 class="bm-card-title flex flex-row gap-1">
                    <span class="flex-1"> Neues Teil auswählen </span>
                    <button class="bm-btn bm-btn-sm bm-btn-ghost" (click)="newPartForm = false">
                      <fa-icon [icon]="['far', 'times']" />
                    </button>
                  </h3>
                  <dl class="bm-dl">
                    <dt>Artikeltyp</dt>
                    <dd>
                      @if (newSelectedArticleTemplate) {
                        <div class="flex flex-row gap-1 items-center">
                          {{ formatArticleTemplate(newSelectedArticleTemplate) }}
                          <button
                            type="button"
                            class="bm-btn bm-btn-square bm-btn-sm bm-btn-ghost"
                            (click)="unselectPartArticleTemplate()"
                          >
                            <fa-icon [icon]="['fas', 'times']" />
                          </button>
                        </div>
                      } @else {
                        <span>keiner ausgewählt</span>
                        <fieldset class="bm-fieldset">
                          <input
                            type="text"
                            class="bm-input"
                            [(ngModel)]="newArticleTemplateTerm"
                            placeholder="Suchbegriff eingeben"
                          />
                          <p class="bm-label">zum Suchbegriff passende Artikeltypen:</p>
                          @for (
                            articleTemplate of articleTemplates
                              | articleTemplateFilter: newArticleTemplateTerm
                              | slice: 0 : 20;
                            track $index
                          ) {
                            <div
                              class="flex flex-row gap-1 items-center"
                              (click)="selectPartArticleTemplate(articleTemplate)"
                            >
                              {{ formatArticleTemplate(articleTemplate) }}
                              <button type="button" class="bm-btn bm-btn-square bm-btn-sm bm-btn-ghost">
                                <fa-icon [icon]="['fas', 'check-square']" />
                              </button>
                            </div>
                          }
                        </fieldset>
                      }
                    </dd>
                    @if (newSelectedArticleTemplate) {
                      <dt>Artikel</dt>
                      <dd>
                        @if (badPartOnly) {
                          <span>nur Badpart erfassen</span>
                        } @else if (newPartSelectedArticle) {
                          <div>
                            {{ formatArticle(newPartSelectedArticle) }}
                            <button
                              type="button"
                              class="bm-btn bm-btn-square bm-btn-sm bm-btn-ghost"
                              (click)="unselectPartArticle()"
                            >
                              <fa-icon [icon]="['fas', 'times']" />
                            </button>
                          </div>

                          <button class="my-2 bm-btn bm-btn-primary" (click)="selectOnlyBadpart()">
                            Keinen Einbau erfassen, nur Badpart
                          </button>
                        } @else {
                          <span>keiner ausgewählt</span>
                          <fieldset class="bm-fieldset">
                            <input
                              type="text"
                              class="bm-input"
                              [(ngModel)]="newPartTerm"
                              placeholder="Suchbegriff eingeben"
                            />

                            <span class="bm-label">zum Suchbegriff passende Artikeltypen:</span>

                            @for (
                              article of searchArticles | articleFilter: newPartTerm | slice: 0 : sliceCountArticles;
                              track $index
                            ) {
                              <div (click)="selectPartArticle(article)">
                                {{ formatArticle(article) }}
                                <button type="button" class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
                                  <fa-icon [icon]="['fas', 'check-square']" />
                                </button>
                              </div>
                            }
                            <a class="bm-link bm-link-ghost" (click)="increaseArticleSliceCount()"> mehr laden </a>
                          </fieldset>

                          <button
                            type="button"
                            class="bm-btn bm-btn-sm bm-btn-primary mt-4"
                            (click)="selectOnlyBadpart()"
                          >
                            Keinen Einbau erfassen, nur Badpart
                          </button>
                        }
                      </dd>
                      @if (newPartSelectedArticle || badPartOnly) {
                        <dt>SN ausgebaut</dt>
                        <dd>
                          <input type="text" class="bm-input bm-input-sm mb-1" [(ngModel)]="newPart.sn_removed" />
                        </dd>
                        <dt>Fehlerbeschreibung</dt>
                        <dd>
                          <input
                            type="text"
                            class="bm-input bm-input-sm mb-1"
                            [(ngModel)]="newPart.error_description"
                          />
                        </dd>
                        <dt></dt>
                        <dd>
                          <button
                            type="input"
                            class="bm-btn bm-btn-primary"
                            (click)="savePart()"
                            [disabled]="newPart.article_id === null && !badPartOnly"
                          >
                            Speichern
                          </button>
                        </dd>
                      }
                    }
                  </dl>
                </section>
              }
            </div>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300 col-span-3">
              <h3 class="bm-card-title bm-card-title-top flex flex-row gap-1 bg-base-100">
                <span> Technikerreport </span>
                <button
                  class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost opacity-25 hover:opacity-100"
                  (click)="editTechnicianReport = !editTechnicianReport"
                >
                  @if (editTechnicianReport) {
                    <fa-icon [icon]="['far', 'times']" />
                  } @else {
                    <fa-icon [icon]="['far', 'edit']" />
                  }
                </button>
              </h3>
              @if (editTechnicianReport) {
                <hawk-shared-edit-input
                  [textValue]="operation.report"
                  [modus]="'textarea'"
                  (saveClicked)="saveTechnicianReport($event)"
                  (cancelClicked)="editTechnicianReport = false"
                />
              } @else if (operation.report) {
                <div [innerHtml]="convertLinebreaks(operation.report, true)"></div>
              }
            </section>
          </div>
        }
        @if (selectedTab == "steps") {
          @for (md of operation.metadata; track $index) {
            <section class="bm-card bm-card-sm bm-card-body">
              <h3 class="bm-card-title">{{ md.name }}</h3>
              @if (parts) {
                <table class="bm-table bm-table-sm bm-table-zebra">
                  @for (step of md.steps; track $index) {
                    @if (false && step.value) {
                      <tr>
                        <td></td>
                        <td>
                          <pre>{{ step | json }}</pre>
                        </td>
                      </tr>
                    }
                    <!-- Fixes a problem that empty (and possibly non necessary steps) were rendered -->
                    @if (step.value) {
                      <tr>
                        <td style="width: 350px">{{ step.name }}</td>
                        <td>
                          @switch (step.stepType) {
                            @case ("yesNo") {
                              {{ step.value == true ? "Ja" : "nein" }}
                            }
                            @case ("timestamp") {
                              {{ step.value | date: "dd.MM.yyyy HH:mm:ss" }}
                            }
                            @case ("articleInput") {
                              Techniker will {{ countMaterials(step.value) }} Teile erfassen<br /><br />

                              erfasst wurden:
                              @for (v of step.value; track $index) {
                                <br />
                                {{ v.amount }}x: {{ v.selected?.title || "ohne Bezeichnung" }}, SNs:
                                {{ getSNForValueEntry(v.serialNumbers).join(", ") }} (SN erfasst:
                                {{ getSNForValueEntry(v.serialNumbers).length }}, nicht erfasst:
                                {{ v.amount - getSNForValueEntry(v.serialNumbers).length }})
                              }
                            }
                            @case ("articleRemoval") {
                              {{ countMaterials(step.value) }} Teil(e) ausgebaut
                            }
                            @case ("articleInstallation") {
                              @switch (articleInstallationFieldType(step.value)) {
                                @case ("sn_list") {
                                  @for (sn of step.value; track $index) {
                                    <hawk-operation-subpage-step-article
                                      [articleId]="sn"
                                    ></hawk-operation-subpage-step-article>
                                    <br />
                                  }
                                }
                                @case ("sn") {
                                  {{ step?.value?.sn?.description }}<br />
                                  <span>SN: </span>{{ step?.value?.sn?.serialNumber?.sn }}<br />
                                }
                                @case ("no_sn") {
                                  {{ step?.value?.no_sn?.amount || 0 }}x {{ step?.value?.no_sn?.description }}
                                }
                                @case ("noSn") {
                                  {{ step?.value?.noSn?.amount || 0 }}x {{ step?.value?.noSn?.description }}
                                }
                              }
                            }

                            @case ("photo") {
                              <a href="{{ getMetadataImagePath(step.value) }}" target="_blank">
                                <img [attr.src]="getMetadataImagePath(step.value)" class="metaImage" />
                              </a>
                            }
                            @case ("signature") {
                              <img [attr.src]="signaturePath(step.value)" />
                            }
                            @default {
                              {{ step.value }}
                            }
                          }
                        </td>
                      </tr>
                    }
                  }
                </table>
              }
            </section>
          }
        }
        @if (selectedTab == "operation_data") {
          <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
            <h3 class="bm-card-title flex flex-row justify-between items-center">
              <span>Einsatzdaten ({{ operationData.length }} Einträge)</span>
              <div class="flex gap-1">
                <button
                  class="bm-btn bm-btn-sm"
                  [class.bm-btn-primary]="operationDataSortMode === 'entry'"
                  [class.bm-btn-ghost]="operationDataSortMode !== 'entry'"
                  (click)="setOperationDataSortMode('entry')"
                  title="Sortierung nach Eintragungszeit"
                >
                  Nach Eintragung
                </button>
                <button
                  class="bm-btn bm-btn-sm"
                  [class.bm-btn-primary]="operationDataSortMode === 'location'"
                  [class.bm-btn-ghost]="operationDataSortMode !== 'location'"
                  (click)="setOperationDataSortMode('location')"
                  title="Sortierung nach Ort (Item SN, Type, Key)"
                >
                  Nach Ort
                </button>
              </div>
            </h3>
            @if (operationData.length > 0) {
              <div class="overflow-x-auto">
                <table class="bm-table bm-table-sm bm-table-zebra">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Item SN</th>
                      <th>Type & Key</th>
                      <th>Werte</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (data of operationData; track data.id) {
                      <tr>
                        <td class="font-mono text-xs">{{ data.id }}</td>
                        <td>{{ data.item_sn || '-' }}</td>
                        <td class="align-top">
                          @if (data.value_type) {
                            <div class="text-sm font-medium text-primary">{{ data.value_type }}</div>
                          }
                          @if (data.value_key) {
                            <div class="text-xs text-base-content/70">{{ data.value_key }}</div>
                          }
                          @if (!data.value_type && !data.value_key) {
                            <span class="text-base-content/50">-</span>
                          }
                        </td>
                        <td>
                          @for (valueEntry of getOperationDataValues(data); track valueEntry.key) {
                            <div class="text-sm mb-1">
                              <span class="font-semibold text-primary">{{ valueEntry.key }}:</span>
                              @if (valueEntry.type === 'filename_image') {
                                <!-- FILENAME# Bild anzeigen -->
                                @if (extractFilenameFromBlob(valueEntry.value)) {
                                  <div class="ml-1 mt-1">
                                    <a
                                      [href]="getOperationImagePath(extractFilenameFromBlob(valueEntry.value)!)"
                                      target="_blank"
                                      class="inline-block"
                                    >
                                      <img
                                        [src]="getOperationImagePath(extractFilenameFromBlob(valueEntry.value)!)"
                                        [alt]="extractFilenameFromBlob(valueEntry.value)"
                                        class="max-h-[100px] border border-base-300 rounded"
                                        style="max-height: 100px;"
                                      />
                                    </a>
                                    <div class="text-xs text-base-content/60 mt-1">
                                      {{ extractFilenameFromBlob(valueEntry.value) }}
                                    </div>
                                  </div>
                                }
                              } @else if (valueEntry.type === 'base64_image') {
                                <!-- Base64 Bild anzeigen -->
                                <div class="ml-1 mt-1">
                                  <a
                                    href="javascript:void(0)"
                                    (click)="openBase64ImageInNewTab(valueEntry.value)"
                                    class="inline-block"
                                  >
                                    <img
                                      [src]="valueEntry.value.startsWith('data:') ? valueEntry.value : 'data:image/png;base64,' + valueEntry.value"
                                      alt="Base64 Image"
                                      class="max-h-[100px] border border-base-300 rounded"
                                      style="max-height: 100px;"
                                    />
                                  </a>
                                  <div class="text-xs text-base-content/60 mt-1">
                                    Base64-Bild ({{ (valueEntry.value.length / 1024).toFixed(1) }}KB)
                                  </div>
                                </div>
                              } @else {
                                <!-- Normaler Text-Wert -->
                                <span class="ml-1">{{ valueEntry.value }}</span>
                              }
                            </div>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <div class="text-center text-base-content/60 py-8">
                <p>Keine Einsatzdaten vorhanden</p>
              </div>
            }
          </section>
        }

        @if (selectedTab == "checklist" && checklistItems) {
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title">Checkliste: {{ checklist.name }}</h3>

              <div class="flex flex-col gap-4">
                @for (item of checklistItems; track item.id) {
                  <div class="bm-card bm-card-sm bm-card-border border-base-200">
                    <div class="bm-card-body p-4">
                      <!-- Question Header -->
                      <h4 class="font-bold text-lg mb-2">
                        <span class="text-gray-500 mr-2">#{{ item.id }}</span>
                        {{ item.text }}
                      </h4>

                      <!-- Answers -->
                      @for (data of getOperationDataForQuestion(item); track data.id) {
                        <div class="ml-6 mb-4 border-l-2 border-primary pl-4">
                          <!-- Values -->
                          @for (val of getOperationDataValues(data); track val.key) {
                            <div class="mb-1">
                              @if (val.type === 'filename_image') {
                                <!-- Inline Image (FILENAME#) -->
                                 <div class="mt-2">
                                    <span class="text-xs text-gray-500 block mb-1">Bild: {{ extractFilenameFromBlob(val.value) }}</span>
                                    <a [href]="getOperationImagePath(extractFilenameFromBlob(val.value))" target="_blank">
                                      <img [src]="getOperationImagePath(extractFilenameFromBlob(val.value))" class="max-w-xs rounded shadow-sm hover:scale-105 transition-transform" />
                                    </a>
                                 </div>
                              } @else if (val.type === 'base64_image') {
                                 <!-- Inline Image (Base64) -->
                                 <div class="mt-2">
                                    <button class="bm-btn bm-btn-xs bm-btn-outline" (click)="openBase64ImageInNewTab(val.value)">Bild anzeigen</button>
                                    <img [src]="val.value.startsWith('data:') ? val.value : 'data:image/png;base64,' + val.value" class="block mt-1 max-w-xs rounded shadow-sm" />
                                 </div>
                              } @else {
                                <!-- Text/Number/Bool Value -->
                                 <div class="text-base break-words">{{ val.value }}</div>
                              }
                            </div>
                          }

                          <!-- Meta Info -->
                          <div class="text-xs text-gray-400 mt-1 flex gap-2">
                             <span>ID: {{ data.id }}</span>
                             <span>Type: {{ data.value_type }}</span>
                             <span>Key: {{ data.value_key }}</span>
                          </div>

                          <!-- Attachments -->
                          @if (data.operation_data_attachments && data.operation_data_attachments.length > 0) {
                             <div class="mt-2">
                                <span class="text-xs font-bold block mb-1">Anhänge:</span>
                                <div class="flex flex-wrap gap-2">
                                  @for (att of data.operation_data_attachments; track att.id) {
                                     @if (att.filename.toLowerCase().endsWith('.jpg') || att.filename.toLowerCase().endsWith('.jpeg') || att.filename.toLowerCase().endsWith('.png') || att.filename.toLowerCase().endsWith('.gif') || att.filename.toLowerCase().endsWith('.webp') || att.filename.toLowerCase().endsWith('.svg')) {
                                       <!-- Inline Image Attachment -->
                                       <a [href]="att.url" target="_blank" class="block">
                                          <img [src]="att.url" class="h-20 w-auto object-cover rounded shadow-sm hover:scale-105 transition-transform" [title]="att.filename" />
                                       </a>
                                     } @else {
                                       <!-- File Attachment Link -->
                                       <a [href]="att.url" target="_blank" class="bm-btn bm-btn-xs bm-btn-outline gap-1">
                                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 6.182l-6.443 6.444a1.5 1.5 0 01-2.122-2.122l4.908-4.909" />
                                          </svg>
                                          {{ att.filename }}
                                       </a>
                                     }
                                  }
                                </div>
                             </div>
                          }

                          <!-- Article Info -->
                          @if (data.article) {
                             <a [href]="'/a/artikel/' + data.article.id" target="_blank" class="block mt-2 p-2 bg-base-200 rounded text-sm text-base-content hover:bg-base-300 transition-colors">
                                <div class="font-bold">{{ data.article.description || 'Artikel' }}</div>
                                <div>SN: {{ data.article.serial_number }}</div>
                                <div class="text-xs text-gray-500">ID: {{ data.article.id }}</div>
                             </a>
                          }
                        </div>
                      }
                      @empty {
                         <div class="ml-6 text-gray-400 italic text-sm">Keine Antwort vorhanden</div>
                      }
                    </div>
                  </div>
                }
              </div>

            </section>
          }
        @if (selectedTab == "mt_result") {
          <!-- FIXME: PUT COMPONENT HERE -->
          <app-mt-result [ticketId]="ticket.id" />
        }
        @if (selectedTab == "material") {
          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col gap-4">
              @if (newMaterialForm) {
                <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                  <h3 class="bm-card-title">
                    Neues Material hinzufügen
                    <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="newMaterialForm = false">
                      <fa-icon [icon]="['far', 'times']" />
                    </button>
                  </h3>
                  <table class="bm-table bm-table-sm">
                    <tr *ngShow="false">
                      <td class="w-0">Artikelnummer</td>
                      <td><input type="text" class="bm-input bm-input-sm" [(ngModel)]="newMaterial.item_nr" /></td>
                    </tr>
                    <tr>
                      <td wdith="0">Typ</td>
                      <td>
                        <span *ngIf="!newMaterialSelectedArticle">keiner ausgewählt</span>
                        <span *ngIf="newMaterialSelectedArticle"
                          >{{ formatArticleTemplate(newMaterialSelectedArticle) }}
                          <a href="" class="technicianAction" (click)="unselectMaterialArticleTemplate()">
                            <fa-icon [icon]="['fas', 'times']" /> </a></span
                        ><br />
                        <ng-container *ngIf="!newMaterialSelectedArticle">
                          <input
                            type="text"
                            class="bm-input bm-input-sm"
                            [(ngModel)]="newMaterialTerm"
                            placeholder="Suchbegriff eingeben"
                          /><br />
                          <small><b>zum Suchbegriff passende Artikel:</b></small
                          ><br />
                          <ng-container
                            *ngFor="
                              let articleTemplate of articleTemplates
                                | articleTemplateFilter: newMaterialTerm
                                | slice: 0 : 5
                            "
                          >
                            <small>{{ formatArticleTemplate(articleTemplate) }}</small>
                            <a
                              href=""
                              class="technicianAction"
                              (click)="selectMaterialArticleTemplate(articleTemplate)"
                            >
                              <fa-icon [icon]="['fas', 'check-square']" />
                            </a>
                            <br />
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                    <tr *ngShow="false">
                      <td class="w-0">Beschreibung</td>
                      <td><input type="text" class="bm-input bm-input-sm" [(ngModel)]="newMaterial.description" /></td>
                    </tr>
                    <tr>
                      <td class="w-0">Anzahl</td>
                      <td><input type="number" class="bm-input bm-input-sm" [(ngModel)]="newMaterial.amount" /></td>
                    </tr>
                    <tr *ngShow="false">
                      <td class="w-0">Status</td>
                      <td>
                        <select
                          name="status"
                          id="status"
                          class="bm-select bm-select-sm"
                          [(ngModel)]="newMaterial.status"
                        >
                          <option
                            *ngFor="let status of materialStatusOptions"
                            [value]="status"
                            [selected]="status === newMaterial.status"
                          >
                            {{ status }}
                          </option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="w-0">Seriennummer</td>
                      <td><input type="text" class="bm-input bm-input-sm" [(ngModel)]="newMaterial.sn" /></td>
                    </tr>
                    <tr>
                      <td class="w-0"></td>
                      <td>
                        <button class="bm-btn bm-btn-primary" (click)="saveMaterial()">Speichern</button>
                      </td>
                    </tr>
                  </table>
                </section>
              }
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title">
                  Benötigtes Material Techniker
                  <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="newMaterialForm = true">
                    <fa-icon [icon]="['far', 'plus']" />
                  </button>
                </h3>
                <table class="bm-table bm-table-sm">
                  <tr>
                    <th>Typ</th>
                    <th>Anzahl</th>
                    <th>Status</th>
                    <th>Beschreibung</th>
                    <th>SN</th>
                    <th>ArtNr</th>
                  </tr>
                  @for (material of ticket.material; track $index) {
                    <tr>
                      <td>{{ material.title }}</td>
                      <td>{{ material.amount }}</td>
                      <td>{{ material.status }}</td>
                      <td>{{ material.description }}</td>
                      <td>{{ material.sn }}</td>
                      <td>{{ material.item_nr }}</td>
                    </tr>
                  }
                </table>
              </section>
            </div>

            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title">Materialeingang</h3>
              <table class="bm-table bm-table-sm">
                <tr>
                  <th class="w-0">Typ</th>
                  <th class="w-0">Anzahl</th>
                  <th>Seriennummern</th>
                </tr>
                <tr *ngFor="let article of []">
                  <td class="w-0">{{ article.title }}</td>
                  <td class="w-0">{{ article.amount }}</td>
                  <td>
                    <span *ngFor="let sn of article.serial_numbers">{{ sn }}</span>
                  </td>
                </tr>
              </table>
            </section>
            @if (articleSummary) {
              <div class="flex flex-row gap-4 col-span-2">
                @if (articleSummary.article_input_compact) {
                  <section class="flex-fill bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                    <h3 class="bm-card-title">Zusammenfassung Material Eingang (Ticket)</h3>
                    <table class="bm-table bm-table-sm">
                      <tr>
                        <th class="w-0">Anzahl</th>
                        <th>Typ</th>
                      </tr>
                      <tr *ngFor="let article of keysFor(articleSummary.article_input_compact)">
                        <td class="w-0">{{ articleSummary.article_input_compact[article]?.length }}x</td>
                        <td>{{ article }}</td>
                      </tr>
                    </table>
                  </section>
                }
                @if (articleSummary.article_installation_compact) {
                  <section class="flex-fill bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                    <h3 class="bm-card-title">Zusammenfassung Material Installation (Ticket)</h3>
                    <table class="bm-table bm-table-sm">
                      <tr>
                        <th class="w-0">Anzahl</th>
                        <th>Typ</th>
                      </tr>
                      <tr *ngFor="let article of keysFor(articleSummary.article_installation_compact)">
                        <td class="w-0">{{ articleSummary.article_installation_compact[article]?.length }}x</td>
                        <td>{{ cleanString(article) }}</td>
                      </tr>
                    </table>
                  </section>
                }
                @if (articleSummary.article_removal_compact) {
                  <section class="flex-fill bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                    <h3 class="bm-card-title">Zusammenfassung Material Ausbau (Ticket)</h3>
                    <table class="bm-table bm-table-sm">
                      <tr>
                        <th class="w-0">Anzahl</th>
                        <th>Typ</th>
                      </tr>
                      <tr *ngFor="let article of keysFor(articleSummary.article_removal_compact)">
                        <td class="w-0">{{ articleSummary.article_removal_compact[article]?.length }}x</td>
                        <td>{{ article }}</td>
                      </tr>
                    </table>
                  </section>
                }
              </div>
            }
          </div>
        }
        @if (selectedTab == "delivery_notes") {
          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col gap-4">
              @if (linkDeliveryNoteForm) {
                <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                  <h3 class="bm-card-title">Lieferschein verlinken</h3>
                  <label class="bm-fieldset-label"> Lieferscheinnummer angeben (z.B. LS-2021-00815) </label>
                  <input type="text" class="bm-input bm-input-sm" [(ngModel)]="deliveryNoteNumberToLink" />
                  <div class="flex flex-row gap-1">
                    <button class="bm-btn" (click)="linkDeliveryNoteForm = false">Abbrechen</button>
                    <button class="bm-btn bm-btn-primary" (click)="linkDeliveryNote()">Speichern</button>
                  </div>
                </section>
              }
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title flex flex-row items-center gap-1">
                  <span class="flex-fill"> Lieferscheine </span>
                  <button class="bm-btn" (click)="linkDeliveryNoteForm = true">
                    <fa-icon [icon]="['far', 'link']" />
                    Lieferschein verlinken
                  </button>
                  <button class="bm-btn" (click)="navigateNewDN()">
                    <fa-icon [icon]="['far', 'plus']" />
                    Neuer Lieferschein
                  </button>
                </h3>
                <table class="bm-table bm-table-sm">
                  <tr *ngFor="let dn of ticket.delivery_notes">
                    <td>
                      <a [routerLink]="['/', 'lieferscheine', dn.id]" target="_blank">
                        <fa-icon [icon]="['far', 'truck']" />
                        {{ dn.number }}
                      </a>
                    </td>
                    <td>
                      <ng-container [ngSwitch]="dn.note_type">
                        <span class="shippingLabel shippingLabel-info" *ngSwitchCase="'incoming'"
                          >Entgegengenommen</span
                        >
                        <span class="shippingLabel shippingLabel-info" *ngSwitchCase="'installed'">Eingebaut</span>
                        <span class="shippingLabel shippingLabel-info" *ngSwitchCase="'removed'">Ausgebaut</span>
                        <span class="shippingLabel shippingLabel-info" *ngSwitchCase="'returned'">Zurückgeschickt</span>
                      </ng-container>
                    </td>
                    <td>
                      <ng-container [ngSwitch]="dn.shipcloud_tracking_status">
                        <span class="shippingLabel shippingLabel-default" *ngSwitchCase="'UNKNOWN'">Unbekannt</span>
                        <span class="shippingLabel shippingLabel-warning" *ngSwitchCase="'TRANSIT'">Unterwegs</span>
                        <span class="shippingLabel shippingLabel-warning" *ngSwitchCase="'OUT_FOR_DELIVERY'"
                          >In Zustellung</span
                        >
                        <span class="shippingLabel shippingLabel-success" *ngSwitchCase="'DELIVERED'">Zugestellt</span>
                      </ng-container>
                      <a
                        href="/warehouse/deliveryNote/{{ dn.id }}/checkShipcloudTrackingStatus"
                        target="_blank"
                        (click)="reloadDeliveryNotes()"
                        style="margin-left: 5px"
                      >
                        <fa-icon [icon]="['far', 'sync-alt']" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="{{ dn.shipcloud_tracking_url }}"
                        target="_blank"
                        style="margin-left: 5px"
                        *ngIf="dn.shipcloud_tracking_url"
                      >
                        Tracking
                      </a>
                    </td>
                    <td>
                      <button (click)="deleteDN(dn.id)">
                        <fa-icon [icon]="['far', 'trash']" />
                      </button>
                    </td>
                  </tr>
                </table>
              </section>
            </div>
            @if (importShipmentForm) {
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title flex flex-row gap-1">
                  <span class="flex-fill"> externe Sendungen hochladen </span>
                </h3>

                <p>
                  gültige Felder: <br />
                  - ticket_id (z.B: MI-20-044100)<br />
                  - carrier (z.B. UPS, DHL)<br />
                  - sendungsnummer (z.B. 1Z6932186861573064 )<br />
                  - versandatum (z.B. 14.08.20)<br />
                  - empfangsplz (z.B. 24251)
                  <br />
                  <br /><br />

                  Upload im <b>csv</b>-Format
                </p>

                <form [formGroup]="shippingImportform" (ngSubmit)="onShippingFileSubmit()">
                  <input type="file" name="importfile" (change)="onShippingFileChange($event)" />
                  <button type="submit">Upload</button>
                </form>

                <div *ngIf="shippingImportStatus == 'running'">
                  <h3>Import läuft, bitte warten!</h3>
                </div>

                <div class="card-body" *ngIf="shippingImportStatus == 'done'">
                  <h3>Abgeschlossen!</h3>
                  <p>Anzahl Fehler: {{ shippingImporterrorIds.length }}</p>
                  <p>Fehlerhafte ids: {{ shippingImporterrorIds | json }}</p>
                  <p>log: {{ shippingImporterrorLog | json }}</p>
                </div>

                <div class="card-body" *ngIf="shippingImportStatus == 'error'">
                  <h3>Fehler!</h3>
                </div>

                <button class="bm-btn" (click)="importShipmentForm = false">Schließen</button>
              </section>
            } @else {
              <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
                <h3 class="bm-card-title flex flex-row gap-1">
                  <span class="flex-fill"> externe Sendungen </span>
                  <button class="bm-btn" (click)="importShipmentForm = true">
                    <fa-icon [icon]="['far', 'plus']" />
                    Neuen Import starten
                  </button>
                </h3>
                <table class="bm-table bm-table-sm">
                  <tr *ngFor="let shipment of ticket.ticket_shipments">
                    <td>
                      <fa-icon [icon]="['far', 'question']" *ngIf="!shipment.api_provider" />
                      <ng-container [ngSwitch]="shipment.last_status" *ngIf="shipment.api_provider">
                        <fa-icon [icon]="['far', 'question']" *ngSwitchCase="'unknown'" />
                        <fa-icon [icon]="['far', 'check']" *ngSwitchCase="'delivered'" />
                        <fa-icon [icon]="['far', 'undo']" *ngSwitchCase="'return_to_sender'" />
                      </ng-container>
                      {{ shipment.carrier }}: {{ shipment.carrier_tracking_no }}
                    </td>
                    <td>
                      {{ shipment.last_update | date: "dd.MM.yyyy HH:mm" }}
                    </td>
                  </tr>
                </table>
              </section>
            }
          </div>
        }
        @if (selectedTab == "billing") {
          <div class="grid grid-cols-2 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">An Kunden</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoiceCustomer = !editInvoiceCustomer">
                  <b>Rechnungsnummer</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoiceCustomer) {
                    {{ operation.invoice }}
                  } @else {
                    <hawk-shared-edit-input
                      [textValue]="operation.invoice"
                      (saveClicked)="saveInvoiceCustomer($event)"
                      (cancelClicked)="editInvoiceCustomer = false"
                    />
                  }
                </dd>

                <dt (click)="editInvoiceAmount = !editInvoiceAmount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoiceAmount) {
                    {{ operation.invoice_amount }}
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoiceAmount($event)"
                      (cancelClicked)="editInvoiceAmount = false"
                    />
                  }
                </dd>
              </dl>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">Von Parnter</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoicePartner = !editInvoicePartner">
                  <b>Rechnungsnummer</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePartner) {
                    {{ operation.invoice_partner }}
                  } @else {
                    <hawk-shared-edit-input
                      [textValue]="operation.invoice_partner"
                      (saveClicked)="saveInvoicePartner($event)"
                      (cancelClicked)="editInvoicePartner = false"
                    />
                  }
                </dd>

                <dt (click)="editInvoicePartnerAmount = !editInvoicePartnerAmount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePartnerAmount) {
                    {{ operation.invoice_partner_amount }}
                    @if (operation.invoice_partner_amount) {
                      €
                    }
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_partner_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoicePartnerAmount($event)"
                      (cancelClicked)="editInvoicePartnerAmount = false"
                    />
                  }
                </dd>
              </dl>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">PO / Bestellung</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoicePOAmount = !editInvoicePOAmount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePOAmount) {
                    {{ operation.invoice_po_order_amount }}
                    @if (operation.invoice_po_order_amount) {
                      €
                    }
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_po_order_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoicePOAmount($event)"
                      (cancelClicked)="editInvoicePOAmount = false"
                    />
                  }
                </dd>
              </dl>
            </section>

            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">POX</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoicePOXAmount = !editInvoicePOXAmount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePOXAmount) {
                    {{ operation.invoice_pox_order_amount }}
                    @if (operation.invoice_pox_order_amount) {
                      €
                    }
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_pox_order_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoicePOXAmount($event)"
                      (cancelClicked)="editInvoicePOXAmount = false"
                    />
                  }
                </dd>
              </dl>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">PO15</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="editInvoicePO15Amount = !editInvoicePO15Amount">
                  <b>Betrag</b>
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost opacity-25 hover:opacity-100">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (!editInvoicePO15Amount) {
                    {{ operation.invoice_po15_order_amount }}
                    @if (operation.invoice_po15_order_amount) {
                      €
                    }
                  } @else {
                    <hawk-shared-edit-input
                      [numberValue]="operation.invoice_po15_order_amount"
                      [modus]="'number'"
                      (saveClicked)="saveInvoicePO15Amount($event)"
                      (cancelClicked)="editInvoicePO15Amount = false"
                    />
                  }
                </dd>
              </dl>
            </section>
          </div>
        }
        @if (selectedTab == "files") {
          <div class="grid grid-cols-2 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">Hinterlegte Dateien</h3>
              <div class="flex flex-col gap-1">
                @for (file of files; track $index; let i = $index) {
                  <div class="flex flex-row items-center gap-1">
                    <a href="{{ file.path }}" target="_blank" class="bm-link bm-link-hover">
                      {{ file.filename }}
                    </a>
                    <button
                      type="button"
                      class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost text-error bm-tooltip"
                      data-tip="Löschen"
                      (click)="deleteFile(file.filename)"
                    >
                      <fa-icon [icon]="['far', 'trash']" />
                    </button>
                    <button
                      type="button"
                      class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost bm-tooltip"
                      data-tip="Umbenennen"
                      (click)="editFileName[i] = true"
                    >
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </div>
                  @if (editFileName[i]) {
                    <hawk-shared-edit-input
                      [textValue]="file.filename"
                      (saveClicked)="updateFilename(file.filename, $event, i)"
                      (cancelClicked)="editFileName[i] = false"
                    />
                  }
                }
                <a
                  href="/r/api/v1/operations/{{ operation.id }}/report_{{ operation.id }}_{{ ticket.id }}.pdf"
                  target="_blank"
                  class="bm-link bm-link-hover"
                >
                  Servicebericht Einsatz (pdf)
                </a>
                <a
                  href="/r/api/v1/tickets/{{ ticket.id }}/report_{{ ticket.id }}.pdf"
                  target="_blank"
                  class="bm-link bm-link-hover"
                >
                  Servicebericht Ticket (pdf)
                </a>
              </div>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">Neue Datei hochladen</h3>
              <div class="flex flex-row gap-1 items-center">
                <span class="bm-input"> Dateiauswahl </span>
                <hawk-shared-file-input (saveClicked)="saveUploadedFile($event)" [multiUpload]="true" />
              </div>
            </section>
          </div>
        }
        @if (selectedTab == "extras") {
          <div class="grid grid-cols-2 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">Workflow Schritte ändern</h3>
              <hawk-workflow-upload-applet [ticketId]="ticket.id" [operationId]="operation.id" />
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">Berichte neu erzeugen</h3>
              <table class="base">
                <tr>
                  <th>Einsatzbericht</th>
                  <td>
                    <a href="/r/api/v1/operations/{{ operation.id }}/regenerate_report.pdf">neu erzeugen</a>
                  </td>
                </tr>
              </table>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">hinterlegte Workflow Schritte</h3>
              <hawk-workflow-upload-applet [projectId]="ticket.project_id" />
            </section>
          </div>
        }
        @if (selectedTab == "mt_bonus") {
          <div class="grid grid-cols-3 gap-4">
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title">Ablehnung hinterlegen</h3>
              <div>hierdurch wird der Status auf Rejected geändert und der entsprechende Code an MT übertragen.</div>
              <fieldset class="bm-fieldset p-0">
                <label class="bm-select w-full">
                  <span class="bm-label w-32">Grund</span>
                  <select class="w-full" [(ngModel)]="mtRejectionSelectedReason" [disabled]="!canReject">
                    @for (typ of mtRejectionReasons; track $index) {
                      <option [ngValue]="typ.key">
                        {{ typ.title }}
                      </option>
                    }
                  </select>
                </label>
                <label class="bm-input w-full">
                  <span class="bm-label w-32">TSRC</span>
                  <input class="w-full" type="text" [disabled]="true" [value]="mtRejectionSelectedReason" />
                </label>
                @if (mtRejectionSelectedReason) {
                  <label class="bm-input w-full">
                    <span class="bm-label w-32">Freitext</span>
                    <input
                      class="w-full"
                      type="text"
                      maxlength="999"
                      [(ngModel)]="mtRejectionText"
                      placeholder="Begründung eingeben"
                      style="width: 100%"
                      [disabled]="!canReject"
                    />
                  </label>
                  <div role="alert" class="bm-alert bm-alert-error bm-alert-soft">
                    <span>Aktion nicht umkehrbar!</span>
                  </div>
                  <button class="bm-btn bm-btn-primary" (click)="sendRejection()" [disabled]="!canReject">
                    Ticket ablehnen
                  </button>
                }
              </fieldset>
            </section>

            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300 row-span-2 col-span-2">
              <h3 class="bm-card-title flex flex-row gap-1">Techniker Werte überschrieben:</h3>
              <table class="bm-table bm-table-xs">
                <tr>
                  <th>id</th>
                  <th>sn</th>
                  <th>sn löschen?</th>
                  <th>sst_id</th>
                  <th>key</th>
                  <th>value</th>
                  <th></th>
                </tr>
                @for (override of mtOverrides; track override.id) {
                  <tr>
                    <td>{{ override.id }}</td>
                    <td>{{ override.sn }}</td>
                    <td>{{ override.delete_item }}</td>
                    <td>{{ override.sst_id }}</td>
                    <td>{{ override.mt_key }}</td>
                    <td>{{ override.mt_value }}</td>
                    <td>
                      <button
                        class="bm-btn bm-btn-square bm-btn-ghost bm-tooltip"
                        (click)="deleteOverride(override)"
                        data-tip="Eintrag löschen"
                      >
                        <fa-icon [icon]="['fas', 'trash']" class="text-error" />
                      </button>
                    </td>
                  </tr>
                }
              </table>

              <fieldset class="bm-fieldset">
                <legend class="bm-fieldset-legend">Neuen Wert überschreiben</legend>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">sn</label>
                  <input
                    class="w-full"
                    type="text"
                    maxlength="30"
                    [(ngModel)]="mtOverridesSn"
                    placeholder="Seriennummer"
                  />
                </label>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">sst_id</label>
                  <input class="w-full" type="text" maxlength="30" [(ngModel)]="mtOverridesSST" placeholder="SST ID" />
                </label>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">key</label>
                  <input class="w-full" type="text" maxlength="50" [(ngModel)]="mtOverridesKey" placeholder="mt_key" />
                </label>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">value</label>
                  <input
                    class="w-full"
                    type="text"
                    maxlength="255"
                    [(ngModel)]="mtOverridesValue"
                    placeholder="mt_value"
                  />
                </label>
                <label class="bm-input w-full">
                  <label class="bm-label w-32">SN löschen</label>
                  <input class="w-full" type="checkbox" [(ngModel)]="mtOverridesDelete" />
                </label>
                <button class="bm-btn bm-btn-primary" (click)="addOverride()">Übeschreiben hinzufügen</button>
              </fieldset>
            </section>
            <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
              <h3 class="bm-card-title flex flex-row gap-1">XML Log</h3>
              <p>folgende Dateien wurden an MT übertragen</p>
              @for (response of ticket.mt_responses; track $index) {
                <pre>{{ response | json }}</pre>
              }
            </section>
          </div>
        }
      </div>
    </div>
  </section>
</div>
